import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import MainLayout from '../../layouts/MainLayout';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const MyJournal = () => {
  const authState = useSelector(state => state.authReducer);
  const [userName, setUserName] = useState(authState.user.name);
  const [tasks, setTasks] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const { journalType } = useParams();
  const [currentPage, setCurrentPage] = useState(0);
  const tasksPerPage = 1;

  const fetchTasks = useCallback(() => {
    const config = {
      url: "/tasks/myjournal",
      method: "post",
      headers: { Authorization: authState.token },
      data: { userId: authState.user._id, journalType: journalType }
    };
    fetchData(config, { showSuccessToast: false }).then(data => setTasks(data.tasks));
  }, [authState.token, fetchData, authState.user._id, journalType]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchTasks();
  }, [authState.isLoggedIn, fetchTasks]);

  const handleView = (taskId) => {
    setSelectedTaskId(prevId => (prevId === taskId ? null : taskId));
  };

  const formatDateTime = (date) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const formatDate = (date) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit'
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatTime = (date) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const sortedTasks = [...tasks].sort((a, b) => new Date(b.taskDate) - new Date(a.taskDate));
  const totalPages = Math.ceil(sortedTasks.length / tasksPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const renderTasks = () => {
    const startIndex = currentPage * tasksPerPage;
    const selectedTasks = sortedTasks.slice(startIndex, startIndex + tasksPerPage);
  
    if (totalPages > 0) {
      return selectedTasks.map((task) => (
        <div
          key={task._id}
          className="p-1 text-gray-600 rounded-md shadow-md text-sm"
          style={{ height: '90vh', overflow: 'auto' }}
        >
          <div className="w-full h-full">
            <div className="text-sm text-gray-500 flex justify-between">
              <p>{userName}</p>
              <p>Journal@Think5Whys</p>
            </div>
            <p className="text-2xl text-blue-900 border-b-4 border-emerald-600">
              {formatDate(task.taskDate)}
            </p>
            <p className="text-xl text-blue-900 bg-yellow-200 mb-4 h-8">{task.title}</p>
            <p className="text-lg text-blue-900">{task.description}</p>
          </div>
        </div>
      ));
    } else {
      return (
        <div
          className="p-1 text-gray-600 rounded-md shadow-md text-sm"
          style={{ height: '90vh', overflow: 'auto' }}
        >
          <div className="w-full h-full">
            <div className="text-sm text-gray-500 flex justify-between">
              <p>{userName}</p>
              <p>Journal@Think5Whys</p>
            </div>
            <p className="text-2xl text-blue-900 border-b-4 border-emerald-600">
              No Entries Found!!
            </p>
          </div>
        </div>
      );
    }
  };
  

  // const sliderSettings = {
  //   dots: true,
  //   infinite: false,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   adaptiveHeight: true,
  //   afterChange: (index) => handlePageChange(index),
  // };

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    afterChange: (index) => handlePageChange(index),
    appendDots: dots => (
      <div
        style={{
          position: 'absolute',
          bottom: '10px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <ul style={{ margin: '0px' }}> {dots} </ul>
      </div>
    ),
    customPaging: i => (
      <div
        style={{
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          background: '#ddd',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '5px'
        }}
      >
        {i + 1}
      </div>
    ),
  };

  return (
    <>
        <div className="my-2 mx-auto max-w-[700px] py-4 bg-blue-200 text-blue-800">
          {loading ? (
            <Loader />
          ) : (
            <Slider {...sliderSettings}>
              {Array.from({ length: totalPages }, (_, index) => (
                <div key={index}>
                  {renderTasks()}
                </div>
              ))}
            </Slider>
          )}
        </div>
    </>
  );
};

export default MyJournal;
